export const regPattern = 'Reaction-ID:(\\d+)-Steps:([\\d;]+)';

export const parseSchemeString = (schemeString) => {
  const reg = new RegExp(regPattern, 'ig');
  const matched = reg.exec(schemeString);

  return {
    rootReactionId: matched && matched[1],
    stepReactionIds: (matched && matched[2] && matched[2].split(';')) || [],
  };
};

export const mapRouteLayoutForEnrollingMultiStepReaction = (routeLayout) =>
  routeLayout.map((item) => {
    const { id, parentId, reaction, substance, yield: yieldVal } = item;
    return {
      id,
      parentId,
      ...(reaction?.reactionId && { reactionId: reaction.reactionId }),
      databaseId: reaction?.databaseId || substance?.databaseId,
      substanceId: substance?.substanceId,
      structure: substance?.structure,
      ...(yieldVal && { yield: yieldVal }),
    };
  });
